export default __webpack_public_path__ + "static/coating-1-537c470e7103c38f24b4710782e1037f.jpeg";